import React, {Component} from 'react';
import {Transition} from 'react-transition-group';
import ProductFilterList from './ProductFilterList';
import {connectToStore} from './Provider';
import {headerSubmenuDuration} from '../config/animation';
import createTaxonomyListFromQuery from '../utils/createTaxonomyListFromQuery';
import without from 'lodash/without';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import find from 'lodash/find';

const DEFAULT_STYLE = {
	transition: `opacity ${headerSubmenuDuration}ms ease-in-out`,
	opacity: 0,
};

const TRANSITION_STYLES = {
	entering: {opacity: 0},
	entered:  {opacity: 1},
	exited:   {opacity: 0},
	exiting:  {opacity: 0},
};

const INITIAL_STATE = {
	query: {},
};

class MobileFilterTakeover extends Component {
	constructor() {
		super();
		
		this.state = {...INITIAL_STATE};
	}

	componentWillReceiveProps = newProps => {
		if (newProps.query !== this.state.query) {
			this.setState({query: newProps.query});
		}
	}

	clearFilters = () => {
		this.setState({query: {}});
	}

	addFilter = filter => {
		const currentFilterValue = this.state.query[filter._type];

		if (isArray(currentFilterValue)) {
			this.setState({
				query: {
					...this.state.query,
					[filter._type]: [
						...currentFilterValue,
						filter.slug,
					],
				}
			});
		} else if (isString(currentFilterValue)) {
			this.setState({
				query: {
					...this.state.query,
					[filter._type]: filter.slug,
				}
			});
		} else {
			this.setState({
				query: {
					...this.state.query,
					[filter._type]: [filter.slug],
				}
			});
		}
	}

	removeFilter = filter => {
		const currentFilterValue = this.state.query[filter._type];

		if (isArray(currentFilterValue)) {
			this.setState({
				query: {
					...this.state.query,
					[filter._type]: without(currentFilterValue, filter.slug),
				}
			});
		} else if (isString(currentFilterValue)) {
			if (currentFilterValue === filter.slug) {
				const newQuery = {...this.state.query};

				delete newQuery[filter._type];

				this.setState({query: newQuery});
			}
		}
	}

	onClickDone = () => {
		this.props.commitFilterChange(this.state.query);
		this.props.closeMobileFilterTakeover();
	}
	
	render() {
		const {
			isMobileFilterTakeoverOpen,
			filters,
			allTaxonomies,
			closeMobileFilterTakeover,
		} = this.props;

		const {
			query
		} = this.state;

		let activeFilters = createTaxonomyListFromQuery(query);

		activeFilters = activeFilters.map(filter => {
			const foundFilter = find(allTaxonomies, {
				_type: filter._type,
				slug: filter.slug,
			});

			return foundFilter || filter;
		});

		return (
			<Transition
				in={isMobileFilterTakeoverOpen}
				mountOnEnter
				unmountOnExit
				appear
				timeout={{
					enter: 0,
					exit: headerSubmenuDuration,
				}}>{(state) => (
				<React.Fragment>
					<div
						className="header__filter-top header__height bg--white bb--gray-border vertical-align-container"
						style={{
							...DEFAULT_STYLE,
							...TRANSITION_STYLES[state]
						}}>
						<div className="full-width">
							<div className="grid-container contained">
								<div className="row">
									<div className="col c6">
										<button
											title="Cancel"
											onClick={closeMobileFilterTakeover}
											name="cancel"
											className="sans--small uppercase fw--600 color--gray-text">
											Cancel
										</button>
									</div>
									<div className="col c6 tr">
										<button
											title="Done"
											onClick={this.onClickDone}
											name="submit"
											className="sans--small uppercase fw--600">
											Done
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						className="header__filter-bottom bg--gray-bg"
						style={{
							...DEFAULT_STYLE,
							...TRANSITION_STYLES[state]
						}}>
						<div className="header__height" />
						<div className="grid-container contained pt6 pb6">
							<ProductFilterList
								query={query}
								filters={filters}
								activeFilters={activeFilters}
								clearFilters={this.clearFilters}
								addFilter={this.addFilter}
								removeFilter={this.removeFilter}
							/>
						</div>
					</div>
				</React.Fragment>
			)}</Transition>
		);
	}
}

const mapStateToProps = ({
	isMobileFilterTakeoverOpen,
}) => ({
	isMobileFilterTakeoverOpen,
});

const mapStoreToProps = ({
	closeMobileFilterTakeover,
}) => ({
	closeMobileFilterTakeover,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(MobileFilterTakeover);